<script>
import bread from '@/components/bread'
export default {
  name: 'Gene_Editing',
  components: { bread },
  data() {
    return {
      currentType: -1,
      types: [
        {name: '慢病毒包装', img: 'gene_editing_service_1.png', ref: '/Virus/Lentivirus_packaging'},
        {name: 'siRNA/miRNA合成', img: 'gene_interference_service_2.png', ref: '/products/siRNA_miRNA_synthesis', size: {width: '110%'}},
        {name: '质粒构建', img: 'gene_editing_service_3.png', ref: '', size: {width: '100%'}}
      ]
    }
  },
  methods: {
    jumpPage(page) {
      if (page && page !== '') {
        const aLink = document.createElement('a')
        aLink.href = page
        aLink.target = '_blank'
        aLink.click()
      }
    }
  }
}
</script>

<template>
  <div class="wrap wrap-tec">
    <div class="banner">
      <img src="@/assets/img/产品及服务/基因调控/基因干扰/banner.png" class="img-fluid">
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;">
      <bread></bread>
    </div>
    <section class="container">
      <div class="texture-body">
        <p>
          基因干扰（Gene Interference），也称为基因沉默（Gene Silencing），是一种通过减少或阻断特定基因表达的技术，可抑制目标基因的转录或翻译，从而降低或消除基因编码的蛋白质功能。基因干扰广泛应用于基因功能研究、药物开发、疾病治疗等领域。        </p>
        <p>		常见的基因干扰实现方式：</p>
        <p>
          <span class="highLightTexture">siRNA：</span>siRNA（小干扰RNA）是一种双链RNA分子，长度一般为20-25个核苷酸。siRNA可直接转染到细胞中，并与细胞内的RNA干扰机制结合，通过与特定mRNA互补配对，诱导mRNA的降解，进而抑制目标基因的表达，基因沉默效果显著。siRNA介导的基因干扰效率高且瞬时，适用于短期实验，如基因功能分析、筛选实验和快速验证实验。
        </p>
        <P>
          擎科生物具备丰富的核酸合成经验，可提供siRNA设计及合成服务，快至3天且拥有丰富的siRNA专用修饰，所有合成的siRNA都经过严格的质控流程，确保产品质量。
        </P>
        <p>
          <span class="highLightTexture">干扰质粒（shRNA质粒）：</span>将特异性干扰序列（如shRNA序列）插入到干扰质粒中，该质粒通常包含一个强启动子（如U6或H1启动子）和一个选择标记。干扰质粒通过转染方式进入细胞后，细胞会转录出shRNA，该shRNA会形成二级结构并被Dicer酶剪切，生成有效的siRNA，从而靶向降解特定的mRNA，减少目标基因的表达水平。
        </p>
        <p>
          这种基因沉默机制使得基因干扰成为一种重要的研究工具。擎科生物采用慢病毒载体表达shRNA，shRNA慢病毒质粒既可直接转染导入细胞，也可包装成慢病毒颗粒后感染靶细胞。载体上编码的抗性标记（如PURO/NEO等）可以方便稳转株的筛选，荧光标记（如GFP/RFP）还能用于观察转染/感染效率并进行流式筛选等操作。
        </p>
        <div class="gene-interference-flow-img">
          <img src="@/assets/img/产品及服务/基因调控/基因干扰/gene_interference_flow.png" />
        </div>
        <p>
          <span class="highLightTexture">干扰慢病毒：</span>慢病毒载体不仅用于基因过表达，也常用于基因干扰。通过将shRNA序列插入慢病毒载体，制备的慢病毒颗粒可以稳定感染宿主细胞，并将shRNA序列整合到宿主基因组中，从而实现长期稳定的基因沉默。这种基因沉默方法适用于需要长期基因表达抑制的实验，常用于基因功能研究、疾病模型构建和基因治疗等领域。
        </p>
        <p>
          擎科生物可提供从序列设计到病毒包装全流程服务，快至15天交付。高效慢病毒包装系统，滴度≥1×10⁸ TU/mL,采用超速离心过滤，高纯度、低残留，可达in vivo级。
        </p>
      </div>

    </section>

    <section class="container">
      <div class="c-title">相关服务<small> Related Services</small></div>
      <ul class="related-services-list flex flex-justify-space-between flex-align-center">
        <li v-for="(item, index) in types" :key="index" class="flex flex-justify-center flex-direction-col flex-align-center"
            @mouseover="currentType = index" @mouseout="currentType = -1"
            @click="jumpPage(item.ref)">
          <div class="service-image flex flex-justify-center flex-align-center">
            <img :src="`/static/images/${item.img}`" :style="item.size">
          </div>

          <p>{{item.name}}</p>
        </li>
      </ul>
    </section>

    <div class="container">
      <qk-consult type="geneInterference"/>
    </div>
  </div>
</template>

<style scoped lang="scss">
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .compose-type1 .neirong{
    display: block!important;
  }
  .effect-lists1{
    flex-wrap: wrap;
    justify-content: flex-start!important;
  }
  .required{
    margin-top: 5px!important;
  }
  .compose-type1{
    padding-bottom: 20px!important;
  }
}
@media screen and (min-width: 641px){
  .effect-lists{
    //display: block!important;
    justify-content: space-between!important;
    flex-wrap:wrap;
    overflow: auto;
    li {
      width: 198px;
      height: 188px;
      &:hover{
        background: #FFFFFF;
        box-shadow: 0px 0px 10px 0px rgba(19,72,157,0.24);
        border-radius: 15px;
      }
    }
  }
}
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title{
  padding-top: 81px;
}
.c-title small{
  margin-top: 10px;
}
.required{
  margin-top: 50px;
  background: none!important;
  margin-left: 0!important;
  font-size: 16px;
}
.desc{
  font-size: 16px;
}

.cons{
  display: none;
}
.texture-body{
  p{
    text-indent: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 29px;
    text-align: justify;
    font-style: normal;
    text-transform: none;
    margin-bottom: 20px;
    &:last-child{
      margin-bottom: 0;
    }
    &.noIndent{
      text-indent: 0;
    }
  }
}

.highLightTexture{
  color: #13489D;
}
.service-process-image{
  img{
    width: 1200px;
  }
}
.case-image{
  margin-top: 50px;
  img {
    width: 1200px;
  }
}
.padding-reset-top{
  padding-top: 0px !important;
}
.service-advantage-bg{
  background: #F6FAFD;
  margin-top: 100px;
}
.service-advantage-content{
  .left {
    padding-bottom: 80px;
    .img-fluid {
      width: 415px; height: 292px;
    }
  }
}
.service-details-table{
  margin-top: 50px;
  margin-bottom: 50px;
  width: 100%;
  border-left: 1px solid #E4E6EA;
  border-top: 1px solid #E4E6EA;
  tr{
    th{
      padding: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      font-style: normal;
      background: #F6FAFD;
      border-bottom: 1px solid #E4E6EA;
      border-right: 1px solid #E4E6EA;
    }
    td{
      padding: 20px;
      padding-left: 30px;
      padding-right: 30px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      font-style: normal;
      border-bottom: 1px solid #E4E6EA;
      border-right: 1px solid #E4E6EA;
    }
  }
}
.related-services-list{
  li{
    transition: all 0.3s;
    cursor: pointer;
    width: 200px;
    height: 200px;
    .service-image {
      width: 105px;
      height: 106px;
    }
    p{
      font-size: 16px;
      line-height: 24px;
      margin-top: 10px;
    }
    &:hover{
      background: #FFFFFF;
      box-shadow: 0px 0px 10px 0px rgba(19,72,157,0.24);
      border-radius: 15px;
    }
  }
}
.gene-interference-flow-img{
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
  img {
    width: 80%;
  }
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>



// WEBPACK FOOTER //
// src/views/products/Gene_interference.vue